export enum ImageGravity {
    Center = 'center',
    TopLeft = 'top-left',
    Top = 'top',
    TopRight = 'top-right',
    Left = 'left',
    Right = 'right',
    BottomLeft = 'bottom-left',
    Bottom = 'bottom',
    BottomRight = 'bottom-right',
}